export const CHAT_UNREAD_REFRESH = 'mingo:chat-unread-refresh';

export function dispatchChatUnreadRefresh() {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(new Event(CHAT_UNREAD_REFRESH));
}
